import { render, staticRenderFns } from "./networkTraffic.vue?vue&type=template&id=b21e68a2&scoped=true&"
import script from "./networkTraffic.vue?vue&type=script&lang=js&"
export * from "./networkTraffic.vue?vue&type=script&lang=js&"
import style0 from "./particulars.css?vue&type=style&index=0&id=b21e68a2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b21e68a2",
  null
  
)

export default component.exports